import './services.feature'
import './services.checkout.js.coffee'
import './services.address-preference'
import './multi_checkout/services.multi-checkout'
import './service.intl-tel-input'
import './services.tracker'
import './services.saved.stores'
import './services.pnotify'
import './services.recaptcha';
import loggerService from '../../utils/loggerService'

import { isEmpty, omit, debounce } from 'lodash-es';
import { CHECKOUT_EVENTS } from '../constants/angular-events';
import { CHECKOUT_TRACKER_TYPE, TRACKER_DEBOUNCE_DURATION } from '../constants/tracker';

app.directive("checkoutDeliveryForm", [
  '$compile'
  '$timeout'
  '$rootScope'
  'mainConfig'
  'featureService'
  'checkoutService'
  'storePickupOptions'
  'storePickupConfig'
  'addressPreferenceService'
  'storePickupAddresses'
  'multiCheckoutService'
  'intlTelInputService'
  'deliveryInfo'
  'trackerService'
  'savedStoresService'
  'pnotifyService'
  '$http'
  '$filter'
  'RecaptchaService'
  (
    $compile
    $timeout
    $rootScope
    mainConfig
    featureService
    checkoutService
    storePickupOptions
    storePickupConfig
    addressPreferenceService
    storePickupAddresses
    multiCheckoutService
    intlTelInputService
    deliveryInfo
    trackerService
    savedStoresService
    pnotifyService
    $http
    $filter
    RecaptchaService
  ) ->
    {
      restrict: 'A'
      scope: false
      link: (scope, element, attrs) ->
        scope.isRecaptchaEnabled = mainConfig.isRecaptchaEnabled
        scope.state = {
          syncRecipientCustomer: false
        }
        scope.savedAddress = []
        scope.userSavedAddress = deliveryInfo.savedAddress
        scope.selectedAddressOption = 
          value: deliveryInfo.selectedAddressIndex
        scope.currentUserDeliveryAddress =
          mainConfig.currentUser?.delivery_addresses;
        scope.saveFields = {
          default_address: false,
          delivery_address: false,
          seven_eleven_store_need_save: false,
          seven_eleven_store_set_default: false,
          family_mart_store_need_save: false,
          family_mart_store_set_default: false
        }
        disableAddressTimer = null

        handleTrackerEvent = (type) ->
          # shoplytics track
          trackerService.track({
            type: type,
            data: {
              event_category: 'Checkout',
            },
          })

        updateDeliveryData = (address, recipientData = {}) ->
          $rootScope.$broadcast('checkout.address_module.auto_fill', address, true)
          checkoutService.getElement('order[delivery_data][recipient_name]').val(recipientData.recipient_name)
          checkoutService.getElement('order[delivery_data][recipient_phone]').val(recipientData.recipient_phone)

          # shoplytics track
          if recipientData.recipient_name
            handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_NAME_INPUT)
          if recipientData.recipient_phone
            handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_PHONE_INPUT)

          if $(checkoutService.recipientIntlKey).length > 0
            if recipientData.recipient_phone_country_code
              intlTelInputService.setCountry('number', $(checkoutService.recipientIntlKey), recipientData.recipient_phone_country_code)
              intlTelInputService.setPhone('complete', $(checkoutService.recipientIntlKey), recipientData.recipient_phone)
            else if recipientData.recipient_phone
              intlTelInputService.reset($(checkoutService.recipientIntlKey))
            else
              intlTelInputService.setCountry('abbr', $(checkoutService.recipientIntlKey), mainConfig.requestCountry.toLowerCase())

        getSavedAddress = () ->
          addressPreferenceService.getAddressPreferenceData({
            country: deliveryInfo.country,
            scope: addressPreferenceService.PREFERENCE_SCOPE.INPUT_WITHOUT_COUNTRY,
          })
            .then((preferenceData) -> 
              scope.userSavedAddress.map((deliveryData) ->
                addressPreferenceService.transformDeliveryDataToAddress({ 
                  country: deliveryInfo.country,
                  deliveryData: omit(deliveryData, ['recipient_name', 'recipient_phone', 'recipient_phone_country_code']),
                  preferenceData 
                })
            ))
            .then((savedAddress) -> 
              scope.savedAddress = savedAddress
              if !deliveryInfo.isCreatingNewAddress
                updateDeliveryData(savedAddress[deliveryInfo.selectedAddressIndex], scope.userSavedAddress[deliveryInfo.selectedAddressIndex])
            )

        if !multiCheckoutService.isEnabled() && deliveryInfo.showSavedAddresses && scope.userSavedAddress.length > 0
          $rootScope.$on('address_module.template.ready', (event, preferenceScope) -> 
            if preferenceScope != addressPreferenceService.PREFERENCE_SCOPE.DISPLAY
              getSavedAddress()
          )

        scope.storePickupOptions = storePickupOptions
        scope.storePickupConfig = storePickupConfig
        scope.storePickupAddresses = storePickupAddresses
        notifyForRecipientSync = (isChecked) ->
          scope.state.syncRecipientCustomer = isChecked
          $rootScope.$broadcast "checkout.customer.needs_update" if isChecked

        handleTrackerEventDebounced = debounce(handleTrackerEvent, TRACKER_DEBOUNCE_DURATION)

        handleRecipientIsCustomerChecked = (isChecked) ->
          notifyForRecipientSync(isChecked)

          if isChecked
            handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_SAME_RECIPIENT_CLICK)
            handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_NAME_INPUT)
            handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_PHONE_INPUT)

        element.on "click", "input[name='order[delivery_data][recipient_is_customer]']", (event) ->
          isChecked = angular.element(event.currentTarget).is(":checked")
          handleRecipientIsCustomerChecked(isChecked)

        scope.$on "checkout.customer.changed", ($event, payload) ->
          if scope.state.syncRecipientCustomer
            checkoutService.getElement('order[delivery_data][recipient_name]').val(payload.customer_name)
            checkoutService.getElement('order[delivery_data][recipient_phone]').val(payload.customer_phone)
            if $(checkoutService.recipientIntlKey).length > 0
              if payload.customer_country
                intlTelInputService.setCountry('abbr', $(checkoutService.recipientIntlKey), payload.customer_country);
              else
                intlTelInputService.reset($(checkoutService.recipientIntlKey));

        element.on 'input', 'input[name="order[delivery_data][recipient_name]"], input[name="order[delivery_data][recipient_phone]"]', (event) ->
          disableSyncRecipientCustomer()
          if event.target.name == 'order[delivery_data][recipient_name]'
            handleTrackerEventDebounced(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_NAME_INPUT)
          
          if event.target.name == 'order[delivery_data][recipient_phone]'
            handleTrackerEventDebounced(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_PHONE_INPUT)

        element.on('countrychange', checkoutService.recipientIntlKey, () ->
          customerIntlElement = $(checkoutService.customerIntlKey)
          recipientIntlElement = $(checkoutService.recipientIntlKey)
          customerCountryCode = if customerIntlElement.length > 0 then intlTelInputService.getCountry('abbr', customerIntlElement) else ''
          recipientCountryCode = if recipientIntlElement.length > 0 then intlTelInputService.getCountry('abbr', recipientIntlElement) else ''
          if customerCountryCode != recipientCountryCode
            disableSyncRecipientCustomer()
        )

        $rootScope.$on CHECKOUT_EVENTS.CART.SUMMARY.UPDATED, () ->
          if scope.state.isChangingAddress
            scope.state.isChangingAddress = false
        
        tempDisableChangingAddressFromSavedaddress = ->
          scope.state.isChangingAddress = true
          disableAddressTimer = $timeout(()->
            scope.state.isChangingAddress = false
          , 500)

        handleAddressSelectionChange = (value) ->
          if value is 'new'
            updateDeliveryData()
            recipientIsCustomerIsChecked = true
            handleRecipientIsCustomerChecked(recipientIsCustomerIsChecked)
            if ($('.dynamic-delivery-fee').length > 0)
              $timeout.cancel(disableAddressTimer)
              $rootScope.$broadcast CHECKOUT_EVENTS.CART.DELIVERY.RECALCULATE_FEE, { read_only: true }
          else
            updateDeliveryData(scope.savedAddress[value], scope.userSavedAddress[value])
            if ($('.dynamic-delivery-fee').length > 0)
              $timeout.cancel(disableAddressTimer)
              addressNodeData = parseAndSaveLogisticCodeData(JSON.stringify(scope.userSavedAddress[value]))
              if (addressNodeData && addressNodeData.logistic_codes)
                params = { delivery_address: { logistic_codes: addressNodeData.logistic_codes } }
                $rootScope.$broadcast CHECKOUT_EVENTS.CART.DELIVERY.UPDATE_FEE, params
          $rootScope.$broadcast 'tax.fee.address.changed'

        element.on "change", "input[name='form[address]']", (event) ->
          tempDisableChangingAddressFromSavedaddress()
          target = angular.element(event.currentTarget)
          value = target.val()
          handleAddressSelectionChange(value)

        handleSavedStoreTracker = ->
          if scope.selectedStoreOption.value == 'new'
            if deliveryInfo.store_id
              trackerService.track({
                type: CHECKOUT_TRACKER_TYPE.STORE_PICKUP_REMEMBER,
                data: {
                  event_category: 'Checkout',
                  pickup_type: 'N'
                },
              })
            return

          try
            savedStoreData = checkoutService.getElementValue('order[delivery_data]')
            { recipient_name, recipient_phone, location_code } = savedStoreData

            if recipient_name
              handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_NAME_INPUT)
            if recipient_phone
              handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_PHONE_INPUT)
            if location_code
              trackerService.track({
                type: CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_ADDRESS_TYPE,
                data: {
                  event_category: 'Checkout',
                  delivery_type: 'cvs_pickup',
                  delivery_type_detail: deliveryInfo.region_type,
                },
              })

            trackerService.track({
              type: CHECKOUT_TRACKER_TYPE.STORE_PICKUP_REMEMBER,
              data: {
                event_category: 'Checkout',
                pickup_type: 'Y',
              },
            })

          catch e
            loggerService.warn(new Error('failed to handle saved store tracker'), { context: { error: e } })

        element.on 'change', 'input[name="form[store]"]', () ->
          handleSavedStoreTracker()

        scope.$watch('saveFields.default_address', (val) ->
          if val
            scope.saveFields.delivery_address = true
        )

        scope.$watch('saveFields.seven_eleven_store_set_default', (val) ->
          if val
            scope.saveFields.seven_eleven_store_need_save = true
        )

        scope.$watch('saveFields.family_mart_store_set_default', (val) ->
          if val
            scope.saveFields.family_mart_store_need_save = true
        )

        element.on "destroy", (() -> element.off()) # Unbind events

        disableSyncRecipientCustomer = ->
          if angular.element('input[name="order[delivery_data][recipient_is_customer]"]').is(':checked')
            checkoutService.getElement('order[delivery_data][recipient_is_customer]').prop('checked', false)
            scope.state.syncRecipientCustomer = false

        $timeout(()->
          $rootScope.scrollTo($('.delivery-form')) if $('span[name="order[delivery_data][location_code]"]').text()
        ,0)

        parseAndSaveLogisticCodeData = (addressNodeData) ->
          try
            parsedData = JSON.parse(addressNodeData)
            if (parsedData && parsedData.logistic_code)
              $("#dynamic-deliver-fee-logistic-code").val(parsedData.logistic_code)
            return parsedData
          catch e
            console.log(e)

        $timeout(() ->
          if ($('.dynamic-delivery-fee').length > 0)
            try
              params = { status: 'formDefaultAddressCall', read_only: true }
              if !isEmpty(deliveryInfo.recipientData)
                addressNodeData = parseAndSaveLogisticCodeData(JSON.stringify(deliveryInfo.recipientData))
              else if !multiCheckoutService.isEnabled() && deliveryInfo.showSavedAddresses && scope.userSavedAddress.length > 0
                addressNodeData = parseAndSaveLogisticCodeData(JSON.stringify(scope.userSavedAddress[0]))
              else
                $("#dynamic-deliver-fee-logistic-code").val("")

              if (addressNodeData && addressNodeData.logistic_codes)
                params = { delivery_address: { logistic_codes: addressNodeData.logistic_codes } }
              $rootScope.$broadcast CHECKOUT_EVENTS.CART.DELIVERY.UPDATE_FEE, params
            catch e
              console.log(e)

          $(".dynamic-delivery-fee-state-select").change(() ->
            try
              addressNode = JSON.parse($(this).val())
              $('input[name="order[delivery_address][state]"').val(addressNode.name)
              $("#dynamic-deliver-fee-logistic-code").val(addressNode.logistic_code)
              $rootScope.$broadcast CHECKOUT_EVENTS.CART.DELIVERY.UPDATE_FEE
            catch e
              $rootScope.$broadcast CHECKOUT_EVENTS.CART.DELIVERY.RECALCULATE_FEE
          )
        , 0)

        scope.onTimeSlotChange = (payload) ->
          scope.multiCartData[payload.cartTagId].timeSlot = {
            ...scope.multiCartData[payload.cartTagId],
            ...omit(payload, 'cartTagId')
          }

        scope.multiCheckoutService = multiCheckoutService;

        initializeRecipientSyncState = ->
          isChecked = checkoutService.getElement('order[delivery_data][recipient_is_customer]').is(":checked")
          notifyForRecipientSync(isChecked)
          if (isChecked)
            handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_SAME_RECIPIENT_CLICK)

        # Check recipient values: either from default checked recipient_is_customer or existing sessionData
        initialCheckRecipientValue = _.once(() ->
          # because ng-if is used in input[name='order[delivery_data][recipient_name]'] and input[name='order[delivery_data][recipient_phone]']
          # so $timeout is needed to ensure the element has been rendered.
          $timeout(() ->
            initializeRecipientSyncState()

            recipientNameVal = checkoutService.getElementValue('order[delivery_data][recipient_name]')
            if !isEmpty(recipientNameVal)
              handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_NAME_INPUT)

            recipientPhoneVal = checkoutService.getElementValue('order[delivery_data][recipient_phone]')
            if !isEmpty(recipientPhoneVal)
              handleTrackerEvent(CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_PHONE_INPUT)
          , 0)
        )

        initialCheckRecipientValue()

        if multiCheckoutService.isEnabled()
          scope.showStoreSaveCheckbox = (storeType) ->
            mainConfig.currentUser && !deliveryInfo.convenienceStoreInfo?[storeType]?.isSelectedStoreSaved && deliveryInfo.convenienceStoreInfo?[storeType]?.savedStores?.length < 5

          initMultiCartStoreSaveField = () ->
            storeTypes = ['seven_eleven', 'family_mart']
            storeTypes.forEach((storeType) ->
              if deliveryInfo.convenienceStoreInfo?[storeType]?.savedStores?.length == 0
                scope.saveFields["#{storeType}_store_need_save"] = true
            )

          initMultiCartStoreSaveField()

        if !multiCheckoutService.isEnabled() || window.location.search.includes('page_id')
          scope.savedStores = [...deliveryInfo.savedStores]

          storeIdMap = scope.savedStores.reduce((acc, store) ->
            acc[store.delivery_data.location_code] = store._id
            acc
          , {})

          scope.selectedStoreOption = 
            value: if deliveryInfo.isNewStoreRadioSelected
              'new'
            else if deliveryInfo.store_id
              storeIdMap[deliveryInfo.store_id] || 'new'
            else
              scope.savedStores[0]?._id

          scope.hasSavedStores = () -> deliveryInfo.isSavedStoresEnable && scope.savedStores.length > 0
          scope.noSavedStores = () -> deliveryInfo.isSavedStoresEnable && scope.savedStores.length == 0

          scope.showStoreRadioList = () -> mainConfig.currentUser && scope.hasSavedStores()

          scope.isCreatingNewStore = () -> scope.selectedStoreOption.value == 'new' || !scope.hasSavedStores()

          scope.showStoreSaveCheckbox = () ->
            noSavedStoresWithStoreSelected = scope.savedStores.length == 0 && deliveryInfo.store_id
            newStoreSelectedWithLimitAvailable = scope.selectedStoreOption.value == 'new' && deliveryInfo.store_id && scope.savedStores.length < 5

            return mainConfig.currentUser &&
            deliveryInfo.isSavedStoresEnable && (noSavedStoresWithStoreSelected || newStoreSelectedWithLimitAvailable)
          
          scope.handleStoreSelectionChange = () ->
            updateFormDataFromSavedStores()
            
            $timeout(() ->
              
              if scope.selectedStoreOption.value == 'new'
                updateDeliveryInfoStoreId()
                # Handle recipient sync for new store
                recipientIsCustomerIsChecked = true
                handleRecipientIsCustomerChecked(recipientIsCustomerIsChecked)
            , 0)

          scope.removeStore = (store) ->
            savedStoresService.removeStore({
              userId: store.user_id,
              type: store.type,
              locationCode: store.delivery_data.location_code,
            }).then(() ->
              scope.savedStores = scope.savedStores.filter((item) -> item._id != store._id)
              
              if store._id == scope.selectedStoreOption.value && scope.savedStores.length > 0
                scope.selectedStoreOption.value = scope.savedStores[0]._id
              else if scope.savedStores.length == 0
                scope.selectedStoreOption.value = 'new'

              $timeout(() ->
                if scope.savedStores.length == 0
                  isChecked = checkoutService.getElement('order[delivery_data][recipient_is_customer]').is(":checked")
                  handleRecipientIsCustomerChecked(isChecked)
                  updateDeliveryInfoStoreId()
                  initStoreSaveField()
              , 0)
            ).catch(() ->
              pnotifyService.notify(
                $filter('translate')('saved_stores.update.failure'),
                {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                }
              )
            )

          updateFormDataFromSavedStores = () ->
            if scope.selectedStoreOption.value == 'new'
              return

            selectedStore = scope.savedStores.find((store) -> store._id == scope.selectedStoreOption.value)
            { delivery_data } = selectedStore

            scope.currentSelectedStoreForElements = {
              recipient_name: selectedStore.recipient_name
              recipient_phone: selectedStore.recipient_phone
              recipient_phone_country_code: selectedStore.recipient_phone_country_code
              location_code: delivery_data.location_code
              location_name: delivery_data.location_name
              store_address: delivery_data.store_address
            };

          initStoreSaveField = () ->
            scope.saveFields.seven_eleven_store_need_save = true
            scope.saveFields.family_mart_store_need_save = true

          # deliveryInfo.store_id doesn't include @order_preference, so that during the second checkout the radio button can correctly highlight the first option
          # Therefore, if the locationCode on the screen has a value but deliveryInfo.store_id is empty, it means the data comes from @order_preference
          # and needs to be synchronized to deliveryInfo.store_id
          updateDeliveryInfoStoreId = () ->
            locationCode = checkoutService.getElementValue('order[delivery_data][location_code]')

            if !deliveryInfo.store_id && !isEmpty(locationCode)
              deliveryInfo.store_id = locationCode

          if scope.hasSavedStores()
            updateFormDataFromSavedStores()
            
            # because ng-if is used in input[name='order[delivery_data]'], $timeout is needed to ensure the element has been rendered.
            $timeout(() ->
              handleSavedStoreTracker()
            , 0)

          if deliveryInfo.isSavedStoresEnable
            $timeout(() ->
              updateDeliveryInfoStoreId()

              if scope.noSavedStores() && deliveryInfo.store_id
                initStoreSaveField()
            ,0)

        getFullAddress = (addressObject) ->
          { country, city, address_1, address_2 } = addressObject
          return "#{country}.#{city}.#{address_1}.#{address_2}"

        scope.removeAddress = (address, index) ->
          tempDisableChangingAddressFromSavedaddress()
          filterUserSavedAddress = scope.currentUserDeliveryAddress.filter((addr, idx) -> getFullAddress(addr) != getFullAddress(address))

          $http.put "/api/users/#{mainConfig.currentUser._id}", {
            user: {
              delivery_addresses: filterUserSavedAddress
            },
            recaptchable: true,
          }
          .then(({ data }) ->
            scope.currentUserDeliveryAddress = data.data.delivery_addresses
            scope.userSavedAddress = scope.userSavedAddress.filter((_, idx) -> idx != index)

            # selected previous address or selected new address
            if scope.selectedAddressOption.value < index || scope.selectedAddressOption.value == 'new'
              return

            if scope.userSavedAddress.length == 0
              scope.selectedAddressOption.value = 'new'
            else if scope.selectedAddressOption.value == index
              scope.selectedAddressOption.value = 0
            else
              scope.selectedAddressOption.value = scope.selectedAddressOption.value - 1
            handleAddressSelectionChange(scope.selectedAddressOption.value)

          ).catch(() ->
            pnotifyService.notify(
              $filter('translate')('saved_stores.update.failure'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              }
            )
          )

        scope.removeAddressWithRecaptcha = (address, index) -> 
          RecaptchaService.executeWithPromise().then(() -> scope.removeAddress(address, index))
    }
])
